import { useState } from "react";
import "./index.css"; // Make sure to use the new CSS file
import { ChevronDown, ChevronUp } from "lucide-react";

export default function FAQSComponent() {
  const faqs = [
    {
      question: "How do I get started with Orbit Securities Pvt. Limited?",
      answer: (
        <>
          You can contact us through our hotline number{" "}
          <strong>021-32622079</strong>, visit our website at{" "}
          <a
            href="https://orbitsecurities.com.pk"
            target="_blank"
            rel="noopener noreferrer"
            className="faq-link"
          >
            https://orbitsecurities.com.pk
          </a>
          , or visit us in person. Our Sales Team will guide you through the
          process.
        </>
      ),
    },
    {
      question:
        "Where can I find relevant rules and regulations for securities trading?",
      answer: (
        <>
          The PSX Rule Book in the Investor Awareness Section of our website
          contains all relevant information. For specific details, call our
          Customer Care Representative at <strong>021-3262-2078-80</strong> or
          email{" "}
          <a href="mailto:info@orbitsecurities.com.pk" className="faq-link">
            info@orbitsecurities.com.pk
          </a>
          .
        </>
      ),
    },
    {
      question: "What are the risks of securities trading?",
      answer: (
        <>
          All risks related to securities trading are detailed in the Brokerage
          Account Agreement of the OSPL Trade/OSPL Account Opening Form. You can
          access this information at{" "}
          <a
            href="https://orbitsecurities.com.pk/risk-disclosure"
            target="_blank"
            rel="noopener noreferrer"
            className="faq-link"
          >
            https://orbitsecurities.com.pk/risk-disclosure
          </a>
          .
        </>
      ),
    },
    {
      question: "How are my orders processed and settled via internet?",
      answer: (
        <>
          Orders placed through the internet are received at our server and
          immediately sent to the PSX via Fix Protocol. If accepted, the order
          is queued for execution. Securities delivery occurs on the{" "}
          <strong>2nd working day</strong> after transaction execution.
        </>
      ),
    },
    {
      question: "How do you notify clients about their order executions?",
      answer: (
        <>
          Customers can view their order status by logging into their online
          trading accounts. We also send an{" "}
          <strong>order confirmation email</strong> with transaction details at
          the end of the day.
        </>
      ),
    },
    {
      question:
        "What is the procedure to cancel pending orders during system failure?",
      answer: (
        <>
          In case of <strong>IBTS System Failure</strong>, investors can use our
          Call Center services at <strong>021-32622077</strong> to place,
          cancel, or inquire about pending orders.
        </>
      ),
    },
    {
      question:
        "After an investment sale, how quickly will I have access to the proceeds?",
      answer: (
        <>
          The settlement policy for stock transactions is{" "}
          <strong>Trade Date plus 2 business days (T+2)</strong>.
        </>
      ),
    },
    {
      question: "Is there a minimum amount required to open an account?",
      answer: (
        <>
          There is <strong>no minimum requirement</strong> to open an account
          with Orbit Securities Pvt. Limited.
        </>
      ),
    },
    {
      question: "Why should I choose Orbit Securities Pvt. Limited?",
      answer: (
        <>
          <strong>Orbit Securities Limited</strong> ranks among the top
          brokerage houses in the industry and has established a strong
          reputation for itself.
        </>
      ),
    },
    {
      question:
        "What types of services does Orbit Securities Pvt. Limited provide?",
      answer: (
        <>
          We provide a complete package including{" "}
          <strong>first-hand market information</strong>, fast execution via{" "}
          <strong>KATs</strong>, and settlement of transactions.
        </>
      ),
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-heading">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <button className="faq-question" onClick={() => toggleFAQ(index)}>
              <span>{faq.question}</span>
              <span>
                {openIndex === index ? <ChevronUp /> : <ChevronDown />}
              </span>
            </button>
            <div
              className={`faq-answer ${openIndex === index ? "faq-open" : ""}`}
            >
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
